const evaluation = {
  namespaced: true,
  state: {
    organizationId: {}, // 班级ID
    studentId: {}, // 点击当前学生ID
    teachingProjectRow: '',
    averageObj: {}, // 评价学生
    ipadAverageObj: {}, // 评价学生
    groupArr: [], // 课堂评价-小组动图
    schooolObj: {},
    timeObj: {},
    ipadpjgetMenuIDs: [],
    isChangeClass: true
  },
  mutations: {
    getOrganizationId(state, studentOrganizationId) {
      state.organizationId = studentOrganizationId
    },
    getStudentId(state, StudentID) {
      state.studentId = StudentID
    },
    setTeachingProjectRow(state, row) {
      state.teachingProjectRow = row
    },
    // 评价学生
    changeAverageObj(state, val) {
      state.averageObj = val
    },
    // 评价学生-ipad
    changeIpadAverageObj(state, val) {
      state.ipadAverageObj = val
    },
    // 小组-ipad
    changeIpadgroupArr(state, val) {
      state.groupArr = val
    },
    changeSchoolObj(state, val) {
      state.schooolObj = val
    },
    changeTimeObj(state, val) {
      state.timeObj = val
    },
    changePjgetMenuIDs(state, val) {
      state.ipadpjgetMenuIDs = val
    },
    setChangeClass(state, val) {
      state.isChangeClass = val
    }
  }
}
export default evaluation
